import * as React from "react";
import {Fragment} from "react";
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";
import Site from "../../model/site/Site";
import {RootState} from "../../store/reducer/root/RootState";
import {connect} from "react-redux";
import SitesTable from "./table/SitesTable";
import {none, option, Option} from "ts-option";
import Loading from "../ui/loading/Loading";
import SiteListEmptyView from "./SiteListEmptyView";
import Spinner from "../../hiberUiKit/src/atoms/Spinner/Spinner";
import {Dispatch} from "redux";
import {fetchSites} from "../../store/action/site/site";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import {objectIterator} from "../../utils/DictionaryUtils";

const spinner = require("./../../../resources/hiber/img/spinner-orange.png");

interface ReduxProps {
	/**
	 * All sites.
	 */
	sites: Option<Site[]>;
}

interface DispatchProps {
	/**
	 * Fetch Sites
	 */
	fetchSites: () => void
}

type Props = ReduxProps & DispatchProps

class SiteList extends React.PureComponent<Props> {

	componentDidMount() {
		this.props.fetchSites()
	}

	render() {
		if (this.props.sites.isEmpty) {
			return (
				<Spinner imgUrl={spinner} size={72}/>
			);
		}
		else if (this.props.sites.get.length) {
			return (
				<Fragment>
					<PageHeaderView header={"Sites"}/>
					<PageContentView>
						<Loading isLoading={this.props.sites.isEmpty}>
							<SitesTable sites={this.props.sites.getOrElse([])}/>
						</Loading>
					</PageContentView>
				</Fragment>
			);
		}
		else {
			return <SiteListEmptyView/>
		}
	}
}

function mapStateToProps(state: RootState) {
	const sites = objectIterator(state.site.sitesMap);
	return {
		sites: state.site.allSitesFetched ? option(sites) : none
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {fetchSites: () => dispatch(fetchSites(() => {}, err => notifyBugsnagAndShowToast(err, "Fetch Sites")))}
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteList)